<div class="tags-field editable" [ngClass]="{ readonly: readonly }">
  <div class="tags-field__container">
    <ng-container *ngIf="tags && tags.length > 0">
      <span class="labels">
        <span class="label" *ngFor="let tag of tags" [ngClass]="['text-cool-gray-500', 'bg-cool-gray-200']">
          {{ tag }}
        </span>
      </span>
    </ng-container>
    <button *ngIf="!readonly && tags.length" mat-icon-button class="edit-button" (click)="openEditTags()">
      <mat-icon [svgIcon]="'edit'"></mat-icon>
    </button>
    <ng-container *ngIf="!tags.length">
      <button *ngIf="!readonly" mat-icon-button class="edit-button" (click)="openEditTags()">
        <mat-icon [svgIcon]="'add_box'"></mat-icon>
      </button>
    </ng-container>
  </div>
</div>
